// frontend/src/utils/locationUtils.js

// Country name to ISO 3166-1 alpha-2 mapping
const COUNTRY_MAP = {
  // German
  schweiz: "CH",
  deutschland: "DE",
  österreich: "AT",
  osterreich: "AT",
  frankreich: "FR",
  italien: "IT",
  liechtenstein: "LI",
  slowenien: "SI",
  // French
  suisse: "CH",
  allemagne: "DE",
  autriche: "AT",
  france: "FR",
  italie: "IT",
  // English
  switzerland: "CH",
  germany: "DE",
  austria: "AT",
  italy: "IT",
  slovenia: "SI",
  // Italian
  svizzera: "CH",
  germania: "DE",
  // Direct ISO codes
  ch: "CH",
  de: "DE",
  at: "AT",
  fr: "FR",
  it: "IT",
  li: "LI",
  si: "SI",
};

/**
 * Convert ISO 3166-1 alpha-2 code to flag emoji.
 * Maps each letter to its Unicode Regional Indicator Symbol.
 */
export function countryCodeToFlag(code) {
  if (!code || code.length !== 2) return "";
  const upper = code.toUpperCase();
  return String.fromCodePoint(
    ...upper.split("").map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)
  );
}

/**
 * Parse a location string and extract city name and country code.
 *
 * Expected formats:
 *   "Venue, Street, 3900 Brig, Schweiz"  =>  { city: "Brig", country: "Schweiz", countryCode: "CH" }
 *   "Brig, Schweiz"                      =>  { city: "Brig", country: "Schweiz", countryCode: "CH" }
 *   "Some Place"                          =>  { city: "Some Place", country: null, countryCode: null }
 */
export function parseLocation(location) {
  if (!location) return { city: null, country: null, countryCode: null };

  const parts = location.split(",").map((p) => p.trim());

  let city = null;
  let country = null;
  let countryCode = null;

  if (parts.length >= 2) {
    const rawCountry = parts[parts.length - 1];
    countryCode = COUNTRY_MAP[rawCountry.toLowerCase()] || null;
    country = rawCountry;

    // Second-to-last part contains city (possibly with postal code prefix)
    const cityPart = parts[parts.length - 2];
    city = cityPart.replace(/^\d{4,5}\s*/, "");
  } else {
    city = parts[0];
  }

  return { city, country, countryCode };
}

/**
 * Get a short location display string: "City, Country" from a full address.
 */
export function getShortLocation(location) {
  if (!location) return null;
  const parts = location.split(",").map((p) => p.trim());
  if (parts.length >= 3) {
    const cityPart = parts[parts.length - 2].replace(/^\d{4,5}\s*/, "");
    const country = parts[parts.length - 1];
    return `${cityPart}, ${country}`;
  }
  if (parts.length === 2) {
    return location;
  }
  return location;
}
